import Vue from 'vue'
import App from './App'

// disables "you are running vue in development warning in console"
Vue.config.productionTip = false
Vue.config.devtools = false
console.log('environment: ', process.env.NODE_ENV);

new Vue({
  render: h => h(App),
}).$mount('#app')